import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  ProsListGetProMapMarkerQuery,
  ProsListGetProMapMarkerQueryVariables,
} from '@gql/graphql';
import { useMemo } from 'react';

export const PROS_LIST_GET_PRO_MAP_MARKER = graphql(`
  query ProsListGetProMapMarker($where: ProfessionalWhereInput!) {
    searchProfessionals(take: 1, where: $where) {
      professionals {
        id
        onlineBookingEnabled
        unclaimedProfile

        address {
          id
          formatted
        }

        imgs(take: 1) {
          id
          medium
        }

        translations {
          id
          language
          title
          url
        }
      }
    }
  }
`);

export const useGetProMapMarker = (id?: number) => {
  const variables = useMemo((): ProsListGetProMapMarkerQueryVariables => {
    return {
      where: {
        id: { equals: id! },
      },
    };
  }, [id]);

  const { data, loading } = useQuery<
    ProsListGetProMapMarkerQuery,
    ProsListGetProMapMarkerQueryVariables
  >(PROS_LIST_GET_PRO_MAP_MARKER, { variables, skip: id == null });

  return {
    proMapMarker: data?.searchProfessionals?.professionals?.[0],
    proMapMarkerLoading: loading,
  };
};
